import Grid from '@mui/material/Grid';
import { ReactElement } from 'react';
import { useWatch } from 'react-hook-form';

import { formatMonthParam } from '~/utils/date/date';
import { IMedicaidPlanType } from '~/services/api/medicaidPlan/types';
import { IVisitForm } from '~/services/api/visits/types';
import { VIEW_CLIENT } from '~/ui/constants/paths';
import ClientProfileTab from '~/ui/pages/Clients/LocalAdmin/ClientProfile/constants/clientProfileTabs';
import CeChip from '~/ui/pages/Clients/reusable/PersonalDetails/MedicaidPlan/components/CeChip';
import MedicaidTypeLabel from '~/ui/pages/Clients/reusable/PersonalDetails/MedicaidPlan/components/MedicaidTypeLabel';
import getVisitMonth from '~/ui/pages/Visits/utils/getVisitMonth';

import styles from './VisitMedicaidInfo.module.scss';

interface IVisitMedicaidInfoProps {
  medicaidType: IMedicaidPlanType;
  medicaidId: string | null;
  clinicId: string;
  teamId: string;
  clientId: string;
}

const VisitMedicaidInfo = ({
  medicaidType,
  medicaidId,
  clinicId,
  teamId,
  clientId,
}: IVisitMedicaidInfoProps): ReactElement => {
  const date = useWatch<IVisitForm, 'date'>({ name: 'date' });
  const visitMonth = getVisitMonth(date);

  const communityEngagementUrl = `${VIEW_CLIENT.replace(':clientId', clientId).replace(
    ':actTeamId',
    teamId,
  )}?tab=${ClientProfileTab.CommunityEngagement}${
    visitMonth ? `&month=${formatMonthParam(visitMonth)}` : ''
  }`;

  const openCommunityEngagement = () => {
    window.open(communityEngagementUrl, '_blank', 'noopener');
  };

  return (
    <Grid size={{ sm: 9 }} className={styles.info}>
      <div className={styles.field}>
        <span>Medicaid Type</span>
        <span className={styles.value}>
          <MedicaidTypeLabel type={medicaidType} multiline />
        </span>
      </div>
      <div className={styles.field}>
        <span>Medicaid ID</span>
        <span className={styles.value}>{medicaidId || '—'}</span>
      </div>
      <div className={styles.field}>
        <span>Work / Engagement Hours</span>
        <CeChip
          client={{ clinicId, clientId }}
          month={visitMonth}
          onOpen={openCommunityEngagement}
        />
      </div>
    </Grid>
  );
};

export default VisitMedicaidInfo;
